module.exports = __webpack_public_path__ + "helveticaltstd-roman-webfont.4977868ed218ad763c06.svg";


//////////////////
// WEBPACK FOOTER
// C:/Users/jboix/source/repos/classic/OficinaAngular/src/assets/fonts/helveticaltstd-roman-webfont.svg
// module id = ../../../../../src/assets/fonts/helveticaltstd-roman-webfont.svg
// module chunks = styles